import { Date } from "@/components";
import { Typography } from "antd";
import { bool, string } from "prop-types";
import { useIntl } from "react-intl";

const { Text } = Typography;

const DateRange = ({ start, end, showTime }) => {
  const intl = useIntl();

  if (!start || !end)
    return <Text>{intl.formatMessage({ id: "errors.invalidDateRange" })}</Text>;

  return (
    <>
      <Date value={start} showTime={showTime} /> -&nbsp;
      <Date value={end} showTime={showTime} />
    </>
  );
};

DateRange.propTypes = {
  start: string.isRequired,
  end: string.isRequired,
  showTime: bool,
};

export default DateRange;
